import { useContext } from "react";
import { Box, Sheet, Typography, IconButton, Chip, Button, Stack, Divider } from "@mui/joy";
import useMediaQuery from "@mui/material/useMediaQuery";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DoneAllRoundedIcon from "@mui/icons-material/DoneAllRounded";
import { LayoutContext } from "../../context";
import { APIGetEventById, APIGetApplicationDetail } from "../../api";

const CATEGORY_LABEL = {
  event: "Событие",
  application: "Заявка",
  system: "Системное",
  info: "Информация",
};

export default function NotificationsPanel() {
  const {
    centerNotifs, notifPanelOpen, setNotifPanelOpen,
    markNotifRead, markAllNotifsRead,
    tokenEmployee, setModalEvent, setModalApplication,
  } = useContext(LayoutContext);

  const isMobile = useMediaQuery("(max-width:600px)");

  const handleAction = async (n) => {
    if (!n.is_read) markNotifRead(n.id);
    const payload = n.action_payload || {};

    if (n.action_type === "open_event" && payload.event_id) {
      const ev = await APIGetEventById(payload.event_id, tokenEmployee);
      if (ev) { setModalEvent({ event: ev, open: true }); setNotifPanelOpen(false); }
      else alert("Не удалось открыть событие");
    } else if (n.action_type === "open_application" && payload.application_id) {
      const app = await APIGetApplicationDetail(payload.application_id, tokenEmployee);
      if (app) { setModalApplication({ open: true, application: app }); setNotifPanelOpen(false); }
      else alert("Не удалось открыть заявку");
    }
  };

  const actionLabel = (t) =>
    t === "open_event" ? "Открыть событие" :
    t === "open_application" ? "Открыть заявку" : null;

  return (
    <>
      {/* Затемнение фона */}
      <Box
        onClick={() => setNotifPanelOpen(false)}
        sx={{
          position: "fixed", inset: 0, zIndex: 11000,
          background: "rgba(0,0,0,0.35)",
          opacity: notifPanelOpen ? 1 : 0,
          pointerEvents: notifPanelOpen ? "auto" : "none",
          transition: "opacity 0.25s ease",
        }}
      />
      {/* Панель */}
      <Sheet
        sx={{
          position: "fixed", top: 0, right: 0, zIndex: 11001,
          height: "100dvh",
          width: isMobile ? "100vw" : 420,
          maxWidth: "100vw",
          display: "flex", flexDirection: "column",
          boxShadow: "-8px 0 24px rgba(0,0,0,0.12)",
          transform: notifPanelOpen ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.3s cubic-bezier(0.4,0,0.2,1)",
        }}
      >
        {/* Шапка */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2 }}>
          <Typography level="h4">Уведомления</Typography>
          <Stack direction="row" spacing={0.5}>
            <IconButton size="sm" variant="plain" onClick={markAllNotifsRead} title="Прочитать все">
              <DoneAllRoundedIcon />
            </IconButton>
            <IconButton size="sm" variant="plain" onClick={() => setNotifPanelOpen(false)} title="Закрыть">
              <CloseRoundedIcon />
            </IconButton>
          </Stack>
        </Stack>
        <Divider />

        {/* Список */}
        <Box sx={{ flex: 1, overflowY: "auto", p: 1.5 }}>
          {(!centerNotifs || centerNotifs.length === 0) && (
            <Typography level="body-sm" color="neutral" sx={{ textAlign: "center", mt: 4 }}>
              Уведомлений пока нет
            </Typography>
          )}
          <Stack spacing={1}>
            {(centerNotifs || []).map((n) => (
              <Sheet
                key={n.id}
                variant="outlined"
                sx={{
                  p: 1.5, borderRadius: "12px",
                  borderColor: n.is_read ? "neutral.200" : "primary.300",
                  background: n.is_read ? "background.surface" : "primary.50",
                }}
                onMouseEnter={() => { if (!n.is_read) markNotifRead(n.id); }}
              >
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.5 }}>
                  <Chip size="sm" variant="soft" color={n.is_read ? "neutral" : "primary"}>
                    {CATEGORY_LABEL[n.category] || n.category || "Уведомление"}
                  </Chip>
                  <Typography level="body-xs" color="neutral">
                    {n.date_create ? new Date(n.date_create).toLocaleString("ru-RU") : ""}
                  </Typography>
                </Stack>
                <Typography level="title-sm" sx={{ fontWeight: 700 }}>{n.title}</Typography>
                {n.text && <Typography level="body-sm" sx={{ mt: 0.25 }}>{n.text}</Typography>}
                {actionLabel(n.action_type) && (
                  <Button size="sm" variant="solid" color="primary" sx={{ mt: 1, borderRadius: "10px" }}
                    onClick={() => handleAction(n)}>
                    {actionLabel(n.action_type)}
                  </Button>
                )}
              </Sheet>
            ))}
          </Stack>
        </Box>
      </Sheet>
    </>
  );
}